<template>
  <div class="page-header" :style="{ '--sidebar-width': sidebarWidth }">

    <nav class="navbar shadow p-3 bg-secondary">
      <div class="container-fluid">
        <button
            class="btn btn-link text-white d-md-none"
            @click="toggleSidebar"
        >
          <i class="bi bi-list fs-3"></i>
        </button>

        <a
            href="https://gps.trackpro.lv/"
            class="text-white text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
        >
          <i class="bi bi-back"></i>
          {{ $t('header.track-pro-title') }}
        </a>

        <div v-show="isShowAllCompany" class="justify-content-md-end col-12 col-sm-12 col-md-8 col-lg-5 col-xxl-2">
          <AdvancedSelect
              v-model="companyId"
              :items="companyOptions"

              searchable
              :isLoadingOption="loading"
              searchPlaceholder="menu.header.company-placeholder-text"
              textField="text"
              valueField="value"
              @update:modelValue="onChangeCompany"
          />
        </div>

      </div>
    </nav>

  </div>
</template>

<script src="./PageHeader.js"></script>

<style scoped>
  .page-header {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 2000;
  }

  /* MOBILE FIX */
  @media (min-width: 769px) {
    .sidebar.collapsed {
      width: 60px;
    }
  }
</style>